import React from 'react';
import { Switch } from 'react-router-dom';
import ErrorBoundaryRoute from 'app/shared/error/error-boundary-route';
import Scolarite from './newscolarite';

import ListFactures from './listFacture';
import FactureDetail from './facture-details';
import ScolariteDeleteModal from './scolarite-delete-modal';
const Routes = ({ match }) => (
  <>
    <Switch>
      <ErrorBoundaryRoute exact path={`${match.url}/:ecoleid/:anneeScolaireId`} component={Scolarite} />
      <ErrorBoundaryRoute exact path={`${match.url}/:ecoleid/:anneeScolaireId/:id/list`} component={ListFactures} />
      <ErrorBoundaryRoute exact path={`${match.url}/:ecoleid/:anneeScolaireId/:id/details`} component={FactureDetail} />
    </Switch>
    <ErrorBoundaryRoute path={`${match.url}/:ecoleid/:anneeScolaireId/:id/delete`} component={ScolariteDeleteModal} />
  </>
);
export default Routes;
